import myEnv from "./env/get-env";
import getConfig from "./env/config.js";

const env = process.env.EPAAS_ENV || myEnv.getEnv();
const config = getConfig(env);

export const apiUrl = () => {
  return config.API_BASE_URL;
};